import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./DriverNotifications.module.css";

const DriversNotifications = ({
  initialDelay = 15000, // Prima notificare la 15 secunde
  intervalDelay = 2 * 60 * 1000, // Notificare la fiecare 2 minute
  resetDelay = 24 * 60 * 60 * 1000, // O notificare per șofer la fiecare 24 de ore
}) => {
  const [drivers, setDrivers] = useState([]);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [notificationVisible, setNotificationVisible] = useState(false);

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const token = sessionStorage.getItem("token") || localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };

        const response = await axios.get("https://api-backend.full-trucking-service.com/api/drivers", config);
        setDrivers(response.data);
      } catch (error) {
        console.error("Error fetching driver data:", error);
      }
    };

    fetchDrivers();
  }, []);

  useEffect(() => {
    if (drivers.length === 0) return;

    const showNextNotification = () => {
      const lastNotifiedDrivers = JSON.parse(localStorage.getItem("lastNotifiedDrivers")) || {};
      const currentTime = new Date().getTime();
      const today = new Date();

      const driversToNotify = drivers.filter((driver) => {
        const lastNotified = lastNotifiedDrivers[driver._id] || 0;
        return currentTime - lastNotified > resetDelay;
      });

      if (driversToNotify.length === 0) return;

      let nextNotification = null;

      for (const driver of driversToNotify) {
        const licenseExpiry = driver.licenseExpiryDate ? new Date(driver.licenseExpiryDate) : null;
        const passportExpiry = driver.passportExpiryDate ? new Date(driver.passportExpiryDate) : null;

        const daysToLicenseExpiry = licenseExpiry ? Math.ceil((licenseExpiry - today) / (1000 * 60 * 60 * 24)) : null;
        const daysToPassportExpiry = passportExpiry ? Math.ceil((passportExpiry - today) / (1000 * 60 * 60 * 24)) : null;

        if (!driver.licenseExpiryDate && !driver.passportExpiryDate) {
          nextNotification = `Driver ${driver.firstName} ${driver.lastName} has no License or Passport expiration dates added. Please update them.`;
          break;
        }

        if (daysToLicenseExpiry !== null && daysToLicenseExpiry <= 30) {
          nextNotification = `License for ${driver.firstName} ${driver.lastName} expires in ${daysToLicenseExpiry} days.`;
          break;
        }

        if (daysToPassportExpiry !== null && daysToPassportExpiry <= 30) {
          nextNotification = `Passport for ${driver.firstName} ${driver.lastName} expires in ${daysToPassportExpiry} days.`;
          break;
        }
      }

      if (nextNotification) {
        setCurrentNotification(nextNotification);
        setNotificationVisible(true);

        lastNotifiedDrivers[driversToNotify[0]._id] = currentTime;
        localStorage.setItem("lastNotifiedDrivers", JSON.stringify(lastNotifiedDrivers));

        setTimeout(() => {
          setNotificationVisible(false);
        }, 5000);
      }
    };

    const initialTimer = setTimeout(() => {
      showNextNotification();
      const intervalTimer = setInterval(() => {
        showNextNotification();
      }, intervalDelay);

      return () => clearInterval(intervalTimer);
    }, initialDelay);

    return () => clearTimeout(initialTimer);
  }, [drivers, initialDelay, intervalDelay, resetDelay]);

  const handleCloseNotification = () => {
    setNotificationVisible(false);
  };

  if (!notificationVisible || !currentNotification) return null;

  return (
    <div className={styles.drivernotificationContainer}>
      <div className={styles.drivernotification}>
        <p>{currentNotification}</p>
        <button className={styles.drivernotificationcloseButton} onClick={handleCloseNotification}>
          ×
        </button>
      </div>
    </div>
  );
};

export default DriversNotifications;
